// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__mhQCL","content":"Footer_content__MvEdT"};